module.exports = __webpack_public_path__ + "img/business-bnw.13578170.png";